import type { Locale } from '@mv/core/model';

export const LOCALES: Locale[] = ['en', 'nl', 'fr'];
export const DEFAULT_LOCALE: Locale = 'en';

export function isLocale(value: string | null | undefined): value is Locale {
	return value != null && LOCALES.includes(value as Locale);
}

export type { Locale };
